import { render, staticRenderFns } from "./IndustrialTopTen.vue?vue&type=template&id=aa208198&scoped=true"
import script from "./IndustrialTopTen.vue?vue&type=script&lang=js"
export * from "./IndustrialTopTen.vue?vue&type=script&lang=js"
import style0 from "./IndustrialTopTen.vue?vue&type=style&index=0&id=aa208198&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa208198",
  null
  
)

export default component.exports